import React from 'react';
import { Image, Button, Row, Col } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { Icon, ButtonTooltip } from '../../../components';

const CompanyAnnouncementModalShow = ({ announcement }) => {
  const image = announcement.companyAnnouncementImage?.fileUrl;
  const { attachedFileInfo } = announcement;
  const newTab = () => window.open(announcement.link, 'noopener', 'noreferrer');

  return (
    <section className="px-4 pt-3 pb-4">
      <Row className="d-flex justify-content-between align-items-start mb-3">
        <p className="mb-0 text-uppercase font-weight-bold fs-1">{announcement.name}</p>
        <small className="text-muted">
          Publicación: {announcement.startDate} al {announcement.endDate}
        </small>
      </Row>

      {image && (
        <div className="d-flex justify-content-center mb-4">
          <Image className="max-height-300 rounded shadow-sm" src={image} alt={announcement.name} fluid />
        </div>
      )}

      <div className="mb-4 mt-5">
        <div
          className="text-justify white-space-pre-line"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(announcement.description)
          }}
        />
      </div>

      <Row className="mt-5 d-flex justify-content-between align-items-center">
        <Row xs="auto">
          {attachedFileInfo && Object.keys(attachedFileInfo).length > 0 && (
            <>
              <Col xs={2}>
                <ButtonTooltip
                  onClick={() => window.open(attachedFileInfo.fileUrl, '_blank', 'noopener', 'noreferrer')}
                  variant="circle-primary"
                  className="btn-circle"
                  text="Descargar"
                >
                  <Icon icon="download-2" height="16px" width="16px" />
                </ButtonTooltip>
              </Col>
              <Col xs={10} className="d-flex align-items-center">
                <p className="mb-0">Descargar Documento Adjunto</p>
              </Col>
            </>
          )}
        </Row>

        <Col xs="auto">
          {announcement.link && (
            <Button variant="primary" onClick={newTab}>
              IR AL ANUNCIO
            </Button>
          )}
        </Col>
      </Row>
    </section>
  );
};

export default CompanyAnnouncementModalShow;
